import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InherentRiskPluginService } from './inherent-risk.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../modal/modal.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'inherentrisk-edit',
  templateUrl: './inherent-risk-edit.component.html',
  standalone: false
})
export class InherentRiskEditPageComponent extends BaseModalPageComponent implements OnInit, OnDestroy {
  plugin: any;
  editForm: UntypedFormGroup;
  probabilityOptions: any[];
  impactOptions: any[];
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public processing = false;
  private currentControlName: string;

  private sub = new Subscription();

  @ViewChild('probabilityModal', { static: true }) probabilityModal: ModalComponent;
  @ViewChild('impactModal', { static: true }) impactModal: ModalComponent;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('pluginDeleteConfirm', { static: true }) pluginDeleteConfirm: any;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InherentRiskPluginService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateInherentRisk(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.markAsTouched();
  }

  public openProbabilitySelector(controlName: string) {
    this.currentControlName = controlName;
    const control = this.editForm.controls[controlName];
    this.openSelector(this.probabilityModal, this.probabilityOptions, control.value);
  }

  public selectProbabilityMenu(item: any) {
    const control = this.editForm.controls[this.currentControlName];
    const selectedIndex = control.value === item.selectedIndex ? '' : item.selectedIndex;
    control.setValue(selectedIndex);
  }

  public openImpactSelector(controlName: string) {
    this.currentControlName = controlName;
    const control = this.editForm.controls[controlName];
    this.openSelector(this.impactModal, this.impactOptions, control.value);
  }

  public selectImpactMenu(item: any) {
    const control = this.editForm.controls[this.currentControlName];
    const selectedIndex = control.value === item.selectedIndex ? '' : item.selectedIndex;
    control.setValue(selectedIndex);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
    }
  }

  public deletePlugin() {
    this.pluginService.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe(
      (data) => {
        this.goToBack();
      },
      (error) => {
        console.log('error deleting plugin', error);
      }
    );
  }

  private openDeleteConfirm() {
    this.pluginDeleteConfirm.open();
  }

  private gotoEditJsonPage() {
    this.router.navigate([`/inspections/${this.inspectionId}/points/${this.pointId}/plugins/${this.pluginId}/editJson`]);
  }

  private gotoEditPage() {
    this.router.navigate([`/inspections/${this.inspectionId}/points/${this.pointId}/plugins/${this.pluginId}/edit`]);
  }

  private initRoute() {
    this.sub.add(
      this.activatedRoute.params.subscribe((params: Params) => {
        const inspectionId = params['inspectionId'];
        const pointId = params['pointId'];
        const pluginId = params['pluginId'];

        this.inspectionId = inspectionId;
        this.pointId = pointId;
        this.pluginId = pluginId;

        this.initData();
      })
    );
  }

  private initData() {
    this.probabilityOptions = this.pluginService.probabilityKeys.map((key) => ({ value: key, label: key.toString() }));
    this.impactOptions = this.pluginService.getImpactOptions().map((key) => ({ value: key.value, label: key.value.toString() }));
    this.pluginService.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      Probability: new UntypedFormControl(this.plugin.config.InherentRisk.Probability),
      Impact: new UntypedFormControl(this.plugin.config.InherentRisk.Impact),
      Comment: new UntypedFormControl(this.plugin.config.InherentRisk.Comment)
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
